import ContentfulBlockText from "./ContentfulBlockText"
import ContentfulBlockMedia from "./ContentfulBlockMedia/ContentfulBlockMedia"
import ContentfulBlockMediaAndCarousel from "./ContentfulBlockMediaAndCarousel"
import ContentfulBlockCarousel from "./ContentfulBlockCarousel"
import ContentfulBlockResults from "./ContentfulBlockResults"
import ContentfulBlockServiceList from "./ContentfulBlockServiceList"
import ContentfulBlockFocus from "./ContentfulBlockFocus"
import ContentfulBlockInstagramCarousel from "./ContentfulBlockInstagramCarousel"
import ContentfulBlockInstagramFeed from "./ContentfulBlockInstagramFeed"
import ContentfulBlockProjectList from "./ContentfulBlockProjectList"
import ContentfulBlockLatestArticles from "./ContentfulBlockLatestArticles"
import ContentfulBlockAllProjectList from "./ContentfulBlockAllProjectList"
import ContentfulBlockSuggestedProjects from "./ContentfulBlockSuggestedProjects"
import ContentfulBlockClients from "./ContentfulBlockClients"

export default {
    ContentfulBlockText,
    ContentfulBlockMedia,
    ContentfulBlockMediaAndCarousel,
    ContentfulBlockCarousel,
    ContentfulBlockResults,
    ContentfulBlockServiceList,
    ContentfulBlockFocus,
    ContentfulBlockInstagramCarousel,
    ContentfulBlockInstagramFeed,
    ContentfulBlockProjectList,
    ContentfulBlockLatestArticles,
    ContentfulBlockAllProjectList,
    ContentfulBlockSuggestedProjects,
    ContentfulBlockClients,
}